import { Settings as LayoutSettings } from '@ant-design/pro-components';
/**
 * @name
 */
export const themeSettings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
  token?: any;
  siderWidth: number;
} = {
  // 拂晓蓝
  layout: 'mix',
  contentWidth: 'Fluid',
  title: '云栈',
  pwa: false,
  siderWidth: 208,
};
